import { all, takeEvery, put, call } from 'redux-saga/effects';
import { IRequestParams, ICollectionResponse } from '@dash/apiInstance';
import { STRIPE_CARD_STRATEGY } from 'src/helpers/payments';
import ApiInstance from 'src/helpers/apiInstance';
import { sendRequest } from '../../../../../../../helpers/saga';
import notifications from '../../../../../../../redux/notifications/actions';
import { logger } from '../../../../../../../helpers/logger';
import actionTypes from './actionTypes';
import actions from './actions';
import { tableConfig } from '../../../../../../../settings';
import { ICard, ILoadCardsPathParams } from './types';
import { LoadCardsRequestAction } from './actions.d';
import { IType } from '../../details/paymentDetails.types';
import { ICardAddingStrategy } from './cards.types';

const unitCardApi = new ApiInstance('units/:id/cards');
const unitWidgetCardApi = new ApiInstance('units/:id/payment_methods/cards');

const subunitCardApi = new ApiInstance('subunits/:id/cards');
const subunitWidgetCardApi = new ApiInstance('subunits/:id/payment_methods/cards');

const getApi = (type: IType, cardAddingStrategy: ICardAddingStrategy) => {
  if (type === 'subUnit') {
    return cardAddingStrategy === STRIPE_CARD_STRATEGY.api ? subunitCardApi : subunitWidgetCardApi;
  }

  return cardAddingStrategy === STRIPE_CARD_STRATEGY.api ? unitCardApi : unitWidgetCardApi;
};

function* loadCards({ payload }: LoadCardsRequestAction<ILoadCardsPathParams, {}>) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column,
      order,
      filter = '',
      id,
      type,
      cardAddingStrategy,
    } = payload;

    const api = getApi(type, cardAddingStrategy);

    const result: ICollectionResponse<ICard> = yield call<any, IRequestParams<ILoadCardsPathParams, {}>, string>(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(
        actions.loadCardsSuccess({
          cards: result.data?.records,
          total: result.data?.totalCount,
          filteredTotal: result.data?.filteredCount,
        }),
      );
    } else {
      yield put(actions.loadCardsError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_CARDS_REQUEST, loadCards)]);
}
